export default {
      id: "show-usage",
      viewBox: "0 0 26 18",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#show",
      toString: function () {
        return this.url;
      }
    }